import { type ExpenseTag, type ExpenseTagColorEnum } from "@finway-group/shared/lib/models"
import { type Dispatch } from "redux"
import { ExpenseTagService } from "~Shared/services"
import { type CreateExpenseTagAction, type DeleteExpenseTagAction, ExpenseTagActionTypes, type FetchAllExpenseTagsAction } from "~Shared/store/actions/expenseTag/expenseTagTypes"
import { attachTagExpense } from "../expense/expenseActions"
import { type DetachTagExpenseAction, ExpenseActionTypes } from "../expense/expenseTypes"
import { type CancelFetchAction, FetcherActionTypes } from "../fetcher/fetcherTypes"

export const fetchAllExpenseTags = () => async (dispatch: Dispatch) => {
    const { docs: expenseTags } = await ExpenseTagService.fetchAllExpenseTags()

    const cancelFetchAction: CancelFetchAction = {
        type: FetcherActionTypes.CANCEL_FETCH,
        isFetchCancelled: true,
    }

    dispatch(cancelFetchAction)

    const fetchAllExpenseTagsAction: FetchAllExpenseTagsAction = {
        type: ExpenseTagActionTypes.FETCH_ALL_EXPENSE_TAGS,
        expenseTags,
    }

    dispatch(fetchAllExpenseTagsAction)

    return expenseTags
}

export const createExpenseTag =
    (data: { tagName: string; tagColor: ExpenseTagColorEnum }, expenseId?: string, idCallbackFunction?: (id: string) => void) => async (dispatch: Dispatch) => {
        const expenseTag: ExpenseTag = await ExpenseTagService.createExpenseTag(data)

        const createExpenseTagAction: CreateExpenseTagAction = {
            type: ExpenseTagActionTypes.CREATE_EXPENSE_TAG,
            expenseTag,
        }

        dispatch(createExpenseTagAction)

        if (expenseId) {
            await attachTagExpense(expenseTag._id, expenseId)(dispatch)
        }
        idCallbackFunction?.(expenseTag._id)
    }

export const deleteExpenseTag = (expenseTagId: string) => async (dispatch: Dispatch) => {
    await ExpenseTagService.deleteExpenseTag(expenseTagId)

    const deleteExpenseTagAction: DeleteExpenseTagAction = {
        type: ExpenseTagActionTypes.DELETE_EXPENSE_TAG,
        expenseTagId,
    }

    dispatch(deleteExpenseTagAction)

    const detachTagExpenseAction: DetachTagExpenseAction = {
        type: ExpenseActionTypes.DETACH_TAG_EXPENSE,
        expenseTagId,
    }

    dispatch(detachTagExpenseAction)
}
